import { useEffect, useState } from "react";
import useUrlState from "@ahooksjs/use-url-state";
import styled from "styled-components";

import { useTableWorkspace } from "../../hooks/useTableWorkspace";
import { TableContainerScroll } from "../../containers/TableContainerScroll";
import { RowTabs } from "../../components/RowTabs";
import { ShowCount } from "../../components/ShowCount";
import { ContentPagination } from "../../components/ContentPagination";
import { FormsContent, FormsHeading } from "./FormsContent";
import { KeysContent, KeysHeading } from "./KeysContent";
import { StatisticalContent, StatisticalHeading } from "./StatisticalContent";

const Content = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 40px 5px 12px 40px;
`;

const StickyTopContent = styled.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  z-index: 16;
  background-color: white;
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 19px;
`;
const Footer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 20px;
`;

const initialTab = {
  tab: "form",
  perPage: 25,
  page: 1,
  sortBy: "email",
};

export const ApiPage = () => {
  const [tabQuery, setTabQuery] = useUrlState({
    tab: initialTab.tab,
  });
  const [countPage, setCountPage] = useState(0);
  const { query, setPerPage, setQuery, setPage } = useTableWorkspace({
    perPage: initialTab.perPage,
    page: initialTab.page,
    sortBy: initialTab.sortBy,
    name: "",
  });
  const [showTab, setShowTab] = useState(tabQuery.tab);

  const changePaginationHandler = setPage;
  const changePerPageHandler = setPerPage;

  useEffect(() => {
    setQuery({
      name: undefined,
      "per-page": 25,
      page: 1,
    });
    setCountPage(0);
    setShowTab(tabQuery.tab);
  }, [tabQuery.tab]);

  return (
    <Content>
      <TableContainerScroll showScroll={true} height={150}>
        <StickyTopContent>
          <Top>
            {showTab === "form" && <FormsHeading />}
            {showTab === "keys" && <KeysHeading />}
            {showTab === "statistical" && <StatisticalHeading />}
          </Top>
          <RowTabs
            onClick={(val) => {
              setTabQuery({ tab: val });
            }}
            active={showTab}
            items={[
              { name: "Анкеты", value: "form" },
              { name: "Ключи API", value: "keys" },
              { name: "Статистика", value: "statistical" },
            ]}
          />
        </StickyTopContent>

        <>
          {showTab === "form" && <FormsContent />}
          {showTab === "keys" && (
            <KeysContent
              query={{ ...query, perPage: query["per-page"] }}
              onSetCountPage={setCountPage}
            />
          )}
          {showTab === "statistical" && (
            <StatisticalContent
              query={{ ...query, perPage: query["per-page"] }}
              onSetCountPage={setCountPage}
            />
          )}
        </>
      </TableContainerScroll>
      {showTab !== "form" && (
        <Footer>
          <ShowCount
            defaultValue={Number(query["per-page"])}
            onChange={changePerPageHandler}
          />
          {countPage > 1 && (
            <ContentPagination
              force={Number(query.page - 1)}
              onClick={changePaginationHandler}
              pageCount={countPage}
            />
          )}
        </Footer>
      )}
    </Content>
  );
};
